import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from '../store';
import Logo from './Logo';
import MainNavigation from './MainNavigation';
import SiteVirtualTour from './SiteVirtualTour';

export default function SiteMobile() {
    const nav = useSelector((state: RootState) => state.navigation.value);

    return (
        <Box sx={{ minHeight: "100vH", bgcolor: "kr.main" }}>
            <Logo />
            <MainNavigation />
            <SiteVirtualTour nav={nav} />

            <div id="krpano-kr-mobile" style={{ width: window.innerWidth, height: window.innerHeight - 300, display: "none" }}></div>
            <Outlet></Outlet>
        </Box>
    );
}